import React from 'react';
import { useNavigate } from 'react-router-dom';
import { HeartIcon } from '@heroicons/react/24/outline';
import PropertyCard from './PropertyCard';
import { Property } from '../types/Property';

const properties: Property[] = [
  {
    id: '1',
    imageUrl: 'https://picsum.photos/800/600?random=1',
    title: 'Luxury Villa',
    type: 'Villa',
    location: 'Batroun',
    price: 343,
    rating: 5.0,
    nights: 2,
    description: 'Stunning villa with ocean views and private pool',
    features: ['Pool', 'Ocean View', 'Garden', 'BBQ'],
    isFavorite: false
  },
  {
    id: '2',
    imageUrl: 'https://picsum.photos/800/600?random=2',
    title: 'Beachfront Apartment',
    type: 'Apartment',
    location: 'Byblos',
    price: 491,
    rating: 5.0,
    nights: 2,
    description: 'Modern apartment steps from the beach',
    features: ['Beach Access', 'Modern Kitchen', 'Balcony'],
    isFavorite: false
  },
  {
    id: '3',
    imageUrl: 'https://picsum.photos/800/600?random=3',
    title: 'Mountain Chalet',
    type: 'Chalet',
    location: 'Faraya',
    price: 275,
    rating: 4.9,
    nights: 2,
    description: 'Cozy chalet with stunning mountain views',
    features: ['Fireplace', 'Mountain View', 'Parking'],
    isFavorite: false
  },
  {
    id: '4',
    imageUrl: 'https://picsum.photos/800/600?random=4',
    title: 'Historic Townhouse',
    type: 'House',
    location: 'Jounieh',
    price: 420,
    rating: 4.8,
    nights: 2,
    description: 'Beautifully restored historic townhouse in the heart of the city',
    features: ['Historic Building', 'City Center', 'Terrace'],
    isFavorite: false
  }
];

const PropertyGrid: React.FC = () => {
  const navigate = useNavigate();

  const handlePropertyClick = (propertyId: string) => {
    navigate(`/property/${propertyId}`);
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {properties.map((property) => (
          <div 
            key={property.id}
            onClick={() => handlePropertyClick(property.id)}
            className="cursor-pointer transform transition-transform duration-300 hover:scale-[1.02]"
          >
            <PropertyCard property={property} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default PropertyGrid;